<template>
  <div>
    <button
      type="button"
      class="btn btnclass smallerfontsize mr-3 selected"
      @click="form.date.showAllDatesModal = true"
    >
      Datum
    </button>
  
    <b-modal
      id="modal-date"
      v-model="form.date.showAllDatesModal"
      title="Datum"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveDate"
    >
      <!-- Period - dropdown -->
      <b-col
        lg="12"
        class="mb-2"
        @click="closeToolTip"
      >
        <label for="period-select">Period</label>
        <b-form-select
          v-model="publishDateData.tempSelectedPeriod"
          v-b-tooltip.hover.html="toolTipPeriod"
          :options="optionsPeriod"
          size="sm"
        />
      </b-col>

      <!-- Från Datum * - input -->
      <b-row class="my-3 px-3">
        <b-col lg="6">
          <label for="date-from-datepicker">Från datum *</label>
          <date-picker
            id="date-from-datepicker"
            ref="datepickerStartdate"
            v-model="publishDateData.tempStartDate"
            :class="[formValidator.dateFrom ? '' : 'is-invalid', 'datepicker']"           
            :months="form.date.datePicker.months"
            :weekdays="form.date.datePicker.weekdays"            
            :show-week-number="true"
            value-type="format"
            :disabled-date="isFromDateDisabled"
            :clearable="false"
          />
          <b-form-invalid-feedback id="dateFrom-input-feedback">
            Fyll i fältet
          </b-form-invalid-feedback>
        </b-col>
        <b-col lg="6">
          <label for="date-to-datepicker">Till datum *</label>
          <date-picker
            id="date-to-datepicker"
            v-model="publishDateData.tempEndDate"
            :class="[formValidator.dateTo ? '' : 'is-invalid', 'datepicker']"      
            :months="form.date.datePicker.months"
            :weekdays="form.date.datePicker.weekdays"           
            :show-week-number="true"
            value-type="format"
            :disabled-date="isEndDateDisabled"
            :clearable="false"
          />
          <b-form-invalid-feedback id="dateTo-input-feedback">
            Fyll i fältet
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <PublishDate
        v-if="publishDateData.tempSelectedPeriod === 'consumptionperiod'"
        :publish-date-data="publishDateData"
        :datepicker-object="form.date.datePicker"
      />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import PublishDate from './PublishDate.vue';
import {
  isDateNotBetweenTwoDates
} from '../../../assets/js/utils.js';
import dayjs from "dayjs";

  export default {
    name: 'DateModal',
    components: {
        DatePicker,
        PublishDate,
    },
    props: {
      form: {
        type: Object,
        required: true,
      },
    },
  data() {
    return {
        toolTipPeriod: {
            title:
            'Publiceringsperiod = <br/> Visar konsumtion för de titlar som har publiceringsdatum inom perioden. <br/> <br/> Konsumtionsperiod = <br/>Visar konsumtion för ALLA titlar inom perioden och eventuell publiceringsintervall.',
        },
        optionsPeriod: [
            { value: 'publicationperiod', text: 'Publiceringsperiod' },
            { value: 'consumptionperiod', text: 'Konsumtionsperiod' },
        ],
        formValidator: {
            dateFrom: true,
            dateTo: true,
            title_length: null,
            measured_days: null,
            starts: null,
            total_online_rating: null,
            tv_rating: null,
        },
        publishDateData:{
          tempPublishStartDate: "",
          tempPublishEndDate: "",
          tempStartDate: "",
          tempEndDate: "",
          tempSelectedPeriod: "consumptionperiod",
          showPubDate: false
        }
    }
  },
  watch: {
    "publishDateData.tempStartDate"(startDate) {
      let validStartDate =
          dayjs(startDate, "YYYY-MM-DD").format("YYYY-MM-DD") === startDate;
        let validEndDate =
          dayjs(this.publishDateData.tempEndDate, "YYYY-MM-DD").format("YYYY-MM-DD") === this.publishDateData.tempEndDate;
        if (!validEndDate || !validStartDate) {
          return;
        }
        if (startDate > this.publishDateData.tempEndDate)
          this.publishDateData.tempEndDate = startDate;
    },
    "publishDateData.tempEndDate"(endDate) {
      let validStartDate =
          dayjs(this.publishDateData.tempStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") === this.publishDateData.tempStartDate;
        let validEndDate =
          dayjs(endDate, "YYYY-MM-DD").format("YYYY-MM-DD") === endDate;
        if (!validEndDate || !validStartDate) {
          return;
        }
        if (this.publishDateData.tempStartDate > endDate)
          this.publishDateData.tempStartDate = endDate;
    }
  },
    methods: {
      popupIsShown(){
        document.addEventListener("keyup", this.onKeyUp);
        let apiBody = this.$store.state.searchApiBody.payload;
        this.publishDateData.tempStartDate = apiBody.start_date
        this.publishDateData.tempEndDate = apiBody.end_date
        this.publishDateData.tempSelectedPeriod = apiBody.selectedPeriod
        this.publishDateData.showPubDate = apiBody.showPubDate
        this.publishDateData.tempPublishStartDate = apiBody.pub_start_date 
        this.publishDateData.tempPublishEndDate = apiBody.pub_end_date
        setTimeout(() => {
        this.$refs.datepickerStartdate.focus();
      }, "100");
      },
      closeToolTip() {
        this.$root.$emit('bv::hide::tooltip');
      },
      isFromDateDisabled(date) {
        let disableDate = isDateNotBetweenTwoDates(
          date,
          new Date(this.$store.state.systemInfo.publishedFromDate),
          new Date(this.$store.state.systemInfo.publishedToDate),
        );
        return disableDate;
      },
      isEndDateDisabled(date) {
        let disableDate = isDateNotBetweenTwoDates(
          date,
          new Date(this.$store.state.systemInfo.publishedFromDate),
          new Date(this.$store.state.systemInfo.publishedToDate),
        );
        return disableDate;
      },
      saveDate(){
        let payload = this.$store.getters["searchApiBody/getPayload"]
        payload.showPubDate = this.publishDateData.showPubDate
        payload.selectedPeriod = this.publishDateData.tempSelectedPeriod
        payload.start_date = this.publishDateData.tempStartDate
        payload.end_date = this.publishDateData.tempEndDate
        payload.pub_start_date = this.publishDateData.tempPublishStartDate
        payload.pub_end_date = this.publishDateData.tempPublishEndDate
        this.$store.commit(
          'searchApiBody/updatePayload',
          payload,
        );
      },
      popupIsHidden(){
        document.removeEventListener("keyup", this.onKeyUp);
      },
      onKeyUp(event) {
        if (event.key === "Enter" && this.form.date.showAllDatesModal) {
          this.form.date.showAllDatesModal = false;
          this.saveDate()
        }
      },
    }
}
</script>